import React from "react";

interface BackgroundWrapperProps {
  children: React.ReactNode;
}

const BackgroundWrapper: React.FC<BackgroundWrapperProps> = ({ children }) => {
  return (
    <div
      className="
        min-h-screen w-full
        bg-white 
        md:bg-[url('https://cdn.builder.io/api/v1/image/assets%2F3b1072ee4ebe466380c75002669f8b56%2F2b01c58328564873a4a24cad073a4a92?format=webp&width=800')]
        md:bg-cover md:bg-center md:bg-no-repeat md:bg-fixed
      "
    >
      {children}
    </div>
  );
};

export default BackgroundWrapper;
